var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInlineError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error 02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3999 7.00039C1.3999 8.4856 1.9899 9.90999 3.0401 10.9602C4.09031 12.0104 5.51469 12.6004 6.9999 12.6004C8.48512 12.6004 9.9095 12.0104 10.9597 10.9602C12.0099 9.90999 12.5999 8.4856 12.5999 7.00039C12.5999 5.51518 12.0099 4.0908 10.9597 3.04059C9.9095 1.99039 8.48512 1.40039 6.9999 1.40039C5.51469 1.40039 4.09031 1.99039 3.0401 3.04059C1.9899 4.0908 1.3999 5.51518 1.3999 7.00039V7.00039Z",
    stroke: "#E74343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28173 7.13887C6.28173 7.55308 6.61752 7.88887 7.03173 7.88887C7.44595 7.88887 7.78173 7.55308 7.78173 7.13887L7.78173 4.33887C7.78173 3.92465 7.44595 3.58887 7.03173 3.58887C6.61752 3.58887 6.28173 3.92465 6.28173 4.33887L6.28173 7.13887ZM7.54806 10.389C7.39054 10.4943 7.20536 10.5504 7.01592 10.5504C6.7619 10.5504 6.51827 10.4495 6.33864 10.2699C6.15902 10.0903 6.05811 9.84665 6.05811 9.59262C6.05811 9.40319 6.11428 9.21801 6.21953 9.06049C6.32477 8.90298 6.47436 8.78021 6.64938 8.70772C6.8244 8.63522 7.01699 8.61626 7.20278 8.65321C7.38857 8.69017 7.55924 8.78139 7.6932 8.91535C7.82716 9.0493 7.91838 9.21997 7.95533 9.40576C7.99229 9.59156 7.97332 9.78415 7.90083 9.95917C7.82834 10.1342 7.70557 10.2838 7.54806 10.389Z",
    fill: "#E74343"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineError);
export default __webpack_public_path__ + "static/media/inline-error.442532b1530c8c038fbfe8f80b22b178.svg";
export { ForwardRef as ReactComponent };